import { getLastArticleContainer } from '../article-page/helper'

export default function (tns) {
  const lastArticleContainer = getLastArticleContainer()

  if (!lastArticleContainer) {
    return
  }

  const galleries = Array.from(
    lastArticleContainer.querySelectorAll('.gallery')
  )

  galleries.forEach((gallery) => applyTinySlideConfigs(gallery, tns))
  disableGalleryLinkClick(lastArticleContainer)
}

function applyTinySlideConfigs(gallery, tns) {
  removeBRElements(gallery)
  removeElementsClasses(gallery)
  gallery.classList.remove('gallery')
  gallery.classList.add('tns-gallery')

  return tns({
    container: gallery,
    gutter: 0,
    nav: false,
    autoHeight: true,
    items: 1,
    edgePadding: 0,
    preventScrollOnTouch: 'force',
    responsive: {
      640: {
        gutter: 0,
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  })
}

function removeElementsClasses(gallery) {
  const dls = Array.from(gallery.querySelectorAll('dl'))
  return dls.map((item) => item.classList.remove('gallery-item'))
}

function removeBRElements(gallery) {
  const brs = Array.from(gallery.querySelectorAll('br'))
  return brs.map((br) => br.remove())
}

function disableGalleryLinkClick(container) {
  if (!container) {
    return
  }

  const links = Array.from(
    container.querySelectorAll('.ArticleContent .tns-outer .tns-item a')
  )

  links.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault()
    })
  })
}
